// extracted by mini-css-extract-plugin
export var actions = "_2r-0";
export var actionsContainer = "_2r-7";
export var border = "_2r-1";
export var childFullHeight = "_2r-f";
export var collapse = "_2r-2";
export var content = "_2r-a";
export var contentChild = "_2r-e";
export var fullscreen = "_2r-c";
export var hasLeftRadius = "_2r-k";
export var headerContainer = "_2r-3";
export var headerRow = "_2r-5";
export var hidePadding = "_2r-b";
export var navCollapsedGap = "_2r-l";
export var noScrollX = "_2r-m";
export var noScrollY = "_2r-n";
export var noTopPadding = "_2r-i";
export var optOutTopPadding = "_2r-d";
export var pageMain = "_2r-j";
export var pageOuter = "_2r-g";
export var pagePadding = "_2r-8";
export var pageScroll = "_2r-9";
export var profile = "_2r-o";
export var profileContainer = "_2r-p";
export var profileImage = "_2r-q";
export var profileMain = "_2r-r";
export var profileSubtitle = "_2r-t";
export var profileTitle = "_2r-s";
export var showLeftPadding = "_2r-h";
export var tabsPortalSlot = "_2r-6";
export var tabsWrapper = "_2r-4";
export var title = "_2r-u";